<template>
  <v-container
    id="signin"
    class="d-flex justify-center align-center flex-column"
    style="height: 90vh;"
  >
    <div>
        <v-img
          width="350"
          alt="New Wave Lending Logo"
          src="@/assets/images/logos/logo_side_round_w350.png"
        />
    </div>
    <v-card
      :loading="submitting"
      :disabled="submitting"
      class="my-5"
      max-width="450"
      outlined
    >
      <v-form ref="form" @submit.prevent="requestSignIn">
        <v-row class="px-7 pt-7">
          <v-col cols="12" v-if="errorMessage">
            <v-alert type="error">
              <span v-html="errorMessage"></span>
            </v-alert>
          </v-col>
          <v-col cols="12">
            SIGN IN TO PIPELINE
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="credential.userName"
              label="User Name"
              placeholder=" "
              required
              :counter="50"
              :rules="[
                (v) => !!v || 'This field is required.',
                (v) =>
                  (v && v.length <= 50) ||
                  'This field cannot be exceed 50 characters.',
              ]"
            ></v-text-field>
            <v-text-field
              v-model="credential.password"
              label="Password"
              placeholder=" "
              required
              :rules="[
                (v) => !!v || 'This field is required.',
                (v) =>
                  (v && v.length >= 6) ||
                  'Password must be more than 6 characters.',
              ]"
              :append-icon="passwordVisiable ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordVisiable ? 'text' : 'password'"
              hint="At least 6 characters"
              counter
              @click:append="passwordVisiable = !passwordVisiable"
            ></v-text-field>
            <v-checkbox v-model="rememberMe" label="Remember Me"></v-checkbox>
            <v-btn color="primary" type="submit" class="my-3" block>
              Sign In
            </v-btn>
            <v-divider></v-divider>
            <v-btn class="my-3 text-capitalize" color="primary" to="/auth/send-recovery-link" link text block>
              Forgot your password?
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-overlay :value="userOrgProfiles" :opacity="0.9" width="300">
      <v-list 
         light
         width="300"
      >
        <v-subheader class="text-h6">Select security profile</v-subheader>
        <div
          v-for="(profileItem) in userOrgProfiles"
          :key="'divider' + profileItem.userOrgProfileId"
        >
          <v-divider />
          <v-list-item
            :key="'profile' + profileItem.userOrgProfileId"
            :title="profileItem.organizationName"
            @click="selectUserOrgProfile(profileItem.userOrgProfileId)"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ profileItem.securityProfileName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ profileItem.organizationCode }} - ({{ profileItem.organizationName }})
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <small>{{ profileItem.originationChannelName }}</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-overlay>
  </v-container>
</template>

<script>

export default {
  name: "SignIn",
  mounted() {
      this.credential.userName = this.$CryptoJS.AES.decrypt(
        this.$cookies.get("signIn:userName") ?? "",
        this.$store.state.appSettings.securityKey
      ).toString(this.$CryptoJS.enc.Utf8);

      this.credential.password = this.$CryptoJS.AES.decrypt(
        this.$cookies.get("signIn:password") ?? "",
        this.$store.state.appSettings.securityKey
      ).toString(this.$CryptoJS.enc.Utf8);

      this.rememberMe = this.$cookies.get("signIn:rememberMe") === "true" ? true : false;
  },
  data() {
    return {
      submitting: false,
      errorMessage: null,
      passwordVisiable: false,
      rememberMe: false,
      userOrgProfiles: null,
      credential: {
        userName: "",
        password: "",
        userOrgProfileId: null
      },
    };
  },
  methods: {
    async requestSignIn() {
      if (this.$refs.form.validate()) {
        this.submitting = true;

        const ret = await this.$store
        .dispatch("authentication/getUserSecurityProfileList", this.credential)
        .then((resp) => resp)
        .catch((err) => err);

        if(ret.status === 200)
        {
          this.errorMessage = null;
          const userOrgProfileList = ret.data;

          if(userOrgProfileList.length == 1){
            this.selectUserOrgProfile(userOrgProfileList[0].userOrgProfileId);
          }
          else {
            this.userOrgProfiles = userOrgProfileList;
          }
        }
        else {
          this.errorMessage = ret.data;
        }

        this.submitting = false;
      }
    },
    async selectUserOrgProfile(userOrgProfileId){
      this.credential.userOrgProfileId = userOrgProfileId;

      const resp = await this.$store
        .dispatch("authentication/signIn", this.credential)
        .then((resp) => resp)
        .catch((err) => err);

      if(resp.status && resp.status != 200){
        this.errorMessage = resp.data;
        this.userOrgProfiles = null;
      }
      else {
        if (this.rememberMe) {
          this.$store.commit("SET_LOGIN_CREDENTIAL", this.credential);
        } else {
          this.$store.commit("REMOVE_LOGIN_CREDENTIAL");
        }
        
        this.$store.commit("SET_TOKEN", resp.data);
        
        if(!this.$route.query.returnUrl || this.$route.query.returnUrl == '/'){
          this.$router.push({ path: "/pipeline/dashboard" });
        }
        else {
          this.$router.push({ path: this.$route.query.returnUrl });
        }
      }

    },
  },
};
</script>
